import React from 'react';
import { Logo } from './Logo';
const footerLinks = [{
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Terms',
  href: '#terms'
}, {
  label: 'Refund Policy',
  href: '#refunds'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="border-t border-orangey-100 bg-cream px-5 pb-24 pt-9 sm:px-8 sm:pb-9" data-id="element-45" data-mp="36pfs3rou7l34">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center gap-5 text-center" data-id="element-46" data-mp="36n3bbhutfgrn">
        <Logo showTagline data-id="element-47" data-mp="3ud7gvurkdqla" />

        <nav aria-label="Footer" data-id="element-48" data-mp="3991omvfnkca">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-49" data-mp="37fpyt5yq9xf">
            {footerLinks.map(link => <li key={link.href} data-id="element-50" data-mp="3lgopimyzeaqt">
                <a href={link.href} className="text-sm font-semibold text-ink-500 underline-offset-4 transition-colors hover:text-orangey-700 hover:underline" data-id="element-51" data-mp="3qcx8yck7oq3s">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="max-w-xl text-sm leading-relaxed text-ink-400" data-id="element-52" data-mp="3labovo69tsmo">
          Not medical advice. For general feeding guidance — always consult your veterinarian for your dog's specific
          health needs.
        </p>
        <p className="font-mono text-[0.65rem] uppercase tracking-[0.14em] text-ink-400" data-id="element-53" data-mp="3v91ans1afx87">
          © {new Date().getFullYear()} Pawsy Companion
        </p>
      </div>
    </footer>;
}